'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mapStyle = exports.defaultTheme = exports.offsets = exports.sizes = exports.raw = undefined;

var _humps = require('humps');

var _humps2 = _interopRequireDefault(_humps);

var _main = require('./main.scss');

var _main2 = _interopRequireDefault(_main);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    'default': obj
  };
}

var mapStyle = function mapStyle(raw) {
  return _humps2['default'].camelizeKeys(raw);
};

var defaultTheme = mapStyle(_main2['default']);
var exludedIs = ['is-variable', 'is-vcentered', 'is-centered', 'is-gapless', 'is-multiline', 'is-desktop', 'is-mobile'];
var sizes = Object.keys(_main2['default']).filter(function (name) {
  if (exludedIs.indexOf(name) > -1) {
    return false;
  }

  return name.indexOf('is-') > -1 && name.indexOf('offset') === -1;
}).map(_humps2['default'].camelize);
var offsets = Object.keys(_main2['default']).filter(function (name) {
  return name.indexOf('is-offset') > -1;
}).map(_humps2['default'].camelize);
exports.raw = _main2['default'];
exports.sizes = sizes;
exports.offsets = offsets;
exports.defaultTheme = defaultTheme;
exports.mapStyle = mapStyle;
exports['default'] = defaultTheme;